import record from './record'
import warn from './warn'
import map from './map'
import user from './user'
import active from './active'
import component from './component'
import simulate from './simulate'
import info from './info'
export default {
    ...warn,
    ...record,
    ...map,
    ...user,
    ...active,
    ...component,
    ...simulate,
    ...info
}



// WEBPACK FOOTER //
// ./src/api/index.js